import React, { Fragment, useContext, useEffect, useState } from "react";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { PROMOTIONS_COLLECTION } from "../utils/constants";
import { db } from "../firebase-config";
import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { convertCurrencyFormat } from "../helpers";
import { IBusiness, IProduct } from "../interfaces";
import { BUSINESS_COLLECTION, STOCK_COLLECTION } from "../utils/constants";

const MenuList = ({ business }: { business: IBusiness }) => {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState<any>({} as { [key: string]: IProduct[] });
  const [promotions, setPromotions] = useState<any[]>([]);

  const getList = async () => {
    const listCollectionRef = collection(
      db,
      BUSINESS_COLLECTION,
      business.uid,
      STOCK_COLLECTION
    );
    setLoading(true);
    const { docs } = await getDocs(
      query(
        listCollectionRef,
        where("status", "==", "enabled"),
        orderBy("name")
      )
    ).finally(() => setLoading(false));

    // Obtener promociones si existen (localmente)
    let promos: any[] = [];
    try {
      const promosRef = collection(
        db,
        BUSINESS_COLLECTION,
        business.uid,
        PROMOTIONS_COLLECTION
      );
      const promosSnap = await getDocs(query(promosRef));
      promos = promosSnap.docs.map((d) => ({ ...d.data(), id: d.id }));
      setPromotions(promos);
    } catch (err) {
      // silencioso
      promos = [];
      setPromotions([]);
    }

    const categorizedProducts = docs.reduce((acc: any, doc: any) => {
      const data = doc.data();
      const name: string = data.name || "";
      // excluir productos que contengan 'p/promo' o 'personalizado' (case-insensitive)
      const lower = name.toLowerCase();
      if (lower.includes("p/promo") || lower.includes("personalizado"))
        return acc;

      const category = data.category_name;
      if (!acc[category]) {
        acc[category] = [];
      }

      // Add product to its category array
      acc[category].push({ ...data, id: doc.id });

      return acc;
    }, {});

    // Si hay promociones, agrégalas como una categoría separada 'Promociones'
    if (promos && promos.length > 0) {
      categorizedProducts["Promociones"] = promos.map((p) => ({
        name: p.name,
        // usar `value` definido en la promoción (string) como monto del combo
        price: Number(p.value) || 0,
        id: p.id,
      }));
    }

    setList(categorizedProducts);
  };

  useEffect(() => {
    if (business) getList();
  }, [business]);

  return (
    <>
      {loading ? (
        <Grid size={12} display="flex" justifyContent="center" mt={3}>
          <CircularProgress size={120} />
        </Grid>
      ) : (
        <>
          {Object.entries(list).map(([category, products]: any) => (
            <React.Fragment key={category}>
              <Grid size={12} key={category}>
                <Typography fontSize={20} mt={3}>
                  {category}
                </Typography>
              </Grid>
              <Grid size={12}>
                {products.map(({ name, price }: any, index: number) => (
                  <Fragment key={name}>
                    <Box display="flex" p={1.25} justifyContent="space-between">
                      <Typography>{name}</Typography>
                      <Typography>
                        {convertCurrencyFormat(Number(price))}
                      </Typography>
                    </Box>
                    {index !== products.length - 1 && <Divider />}
                  </Fragment>
                ))}
              </Grid>
            </React.Fragment>
          ))}
        </>
      )}
    </>
  );
};

export default MenuList;
